import React, { useEffect, useRef } from 'react'
import lottie from 'lottie-web'

import Page from '../common/Page';
import { BottomMiddle } from '../common/Layout'
import { AnalysisTitle, AnalysisHint } from '../common/Text'

import appLogo from '../../assets/app-logo.svg'

export default function Analysis(props) {    
    const lottieContainer = useRef()
    const timer = useRef()

    useEffect(() => {
        lottie.loadAnimation({           
            container: lottieContainer.current,                       
            animationData: require('../../assets/analysis_loading.json')
        })  
    }, [])

    if (props.visible) {
        timer.current = setTimeout(() => {
            props.nextStep()
        }, 4000);        
    }

    return (
        <Page>                           
            <div ref={lottieContainer} style={{paddingTop: '6rem'}}/>
            <AnalysisTitle style={{marginTop: '1rem'}}>Finding a Verse<br/>for Your Mood</AnalysisTitle>            
            <AnalysisHint style={{marginTop: '1rem'}}>Results will appear in 3 seconds!</AnalysisHint>
            <BottomMiddle>
                <img src={appLogo} alt={"Daily Bible Logo"} style={{width: '10rem', height: '3rem', marginBottom: '1.25rem'}}/>
            </BottomMiddle>
        </Page>
    )    
}